<script>
  export let name;

  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';
  
  let item = [];
  let loading = false;
  let error = false;
  const GALLERY_GRAPHICS_TYPES_KEYS = Object.keys(Constants.GALLERY_GRAPHICS_TYPES);

  function fetchItems(name) {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getGraphicsItem', {name: name})
        .then(response => response.json())
        .then(response => item = response.result.items[0])
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  $: fetchItems(name);
</script>

<!-- HTML ----------------------------------------------------------------------->

{#if loading}
<!-- thumbs[TYPE].length === 0 && !galleryError -->
  <div class="lds-css">
    <div class="lds-eclipse"><div></div></div>
  </div>
  
{:else if item}
  <div>
    <div id="containerItem" class="gallery-graphics-item">
      <i id="typeItem" class="fas fa-2x fa-{Constants.GALLERY_GRAPHICS_TYPES[item.type]} {item.type}"></i>
      <h2 id="titleItem" class="rowItem def_back">
        {item.title_en}
      </h2>
      <div id="bodyItem">
      {#if item.type == 'render' || item.type == 'other'}
        <img src="{Constants.PUBLIC_GRAPHICS_IMAGES + item.name + Constants.GALLERY_FILE_EXT}" alt="" />
      {:else if item.type == 'video' && item.downloads}
        <iframe width="560" height="315" src="{item.downloads}" frameborder="0" 
        title="{item.title_en}" allowfullscreen></iframe>
      {/if}
      </div>
      <div class="rowItem row-border-top">
        <p>
          {item.desc_en}
        </p>
        <!--<p id="graphic_date">{item.added}</p>-->
      </div>
    </div>
  </div>

{:else if error}
  <div class="gallery-error">
    <i class="far fa-times-circle"></i>
    {$_('errors.UNKNOWN')}
  </div>
{/if}


<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

#containerItem {
  #typeItem {
    &.render { color: $idro-gallery-render; }
    &.video { color: $idro-gallery-video; }
    &.other { color: $idro-gallery-other; }
  }
  #bodyItem {
    img {
      max-width:100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>
